import type { TFunction } from "i18next";

/**
 * Backend refusal codes → translated messages (ticket 13).
 *
 * The onboarding pages used to echo `err.response?.data?.error`, which is an
 * English sentence composed by the server — untranslated for an Estonian- or
 * Russian-speaking chairman, and it changes whenever the wording does. The
 * codes are the contract; the sentence is the fallback.
 */
const CODE_KEYS: Record<string, string> = {
  representation_check_unavailable: "onboardErrors.representationCheckUnavailable",
  not_a_representative: "onboardErrors.notARepresentative",
  membership_deactivated: "onboardErrors.membershipDeactivated",
  personal_code_admin_only: "onboardErrors.personalCodeAdminOnly",
};

export function onboardErrorMessage(err: any, t: TFunction): string {
  const code = err?.response?.data?.code;
  if (typeof code === "string" && CODE_KEYS[code]) return t(CODE_KEYS[code]);
  return err?.response?.data?.error || t("onboardErrors.generic");
}
